import type { FaireProductEntity } from "../../entity_types/product";

export const p_mzkgdvvaye: FaireProductEntity = {
  token: "p_mzkgdvvaye",
  type: "product",
  name: "Aloe Vera Liquid Gel - Natural",
  brandToken: "b_yjgecwdpju",
  brandName: "WHOLIFECO",
  imageUrl:
    "https://cdn.faire.com/fastly/fbadd76853b08aeb9c6872cf1df450443a46d4ae9d8825495686bca5306b8128.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cd6b0b7cf879615acc210fa70612e2d530569391218604178463b8a57d1aed88.jpeg",
    "https://cdn.faire.com/fastly/51fe426bfe5f6ef78d5135de632a350c1765c4a33711ebd11e0f84052cd6ae45.jpeg",
    "https://cdn.faire.com/fastly/b2b99233bc6528b1f98ca3cb0dd54ed16968218bc89c00ad437eccc753fa3241.jpeg",
  ],
  priceDollars: 8.62,
  description:
    "Experience the soothing and restorative power of our Aloe Vera Liquid Gel, sourced directly from South Africa for the purest quality. Packed with 99% aloe barbadensis leaf juice, this gel harnesses the nourishing, antifungal, and antibacterial benefits of aloe vera to care for your skin naturally. \n\nPerfect for calming skin irritation and inflammation, this gel provides deep hydration, leaving your skin feeling soft, refreshed, and revitalized. Its gentle formula stimulates skin healing, helps improve complexion and tone, and offers a cooling touch that’s perfect for sunburns, minor cuts, or everyday use. Simply apply a small amount to the affected area for instant relief and nourishment.\n\nFor best results, refrigerate after opening to maintain its freshness. Each jar contains 5 oz of pure, skin-loving goodness—your go-to for natural, effective skin care.\n",
  tags: [],
  msrpDollars: 12.38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:12.378Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
